/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAlertConditionFromJSON, ApiAlertConditionToJSON, } from './ApiAlertCondition';
export function ApiAlertConditionGroupFromJSON(json) {
    return ApiAlertConditionGroupFromJSONTyped(json, false);
}
export function ApiAlertConditionGroupFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'alertId': !exists(json, 'alertId') ? undefined : json['alertId'],
        'alertRequirementId': !exists(json, 'alertRequirementId') ? undefined : json['alertRequirementId'],
        'conditions': !exists(json, 'conditions') ? undefined : (json['conditions'].map(ApiAlertConditionFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
    };
}
export function ApiAlertConditionGroupToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'alertId': value.alertId,
        'alertRequirementId': value.alertRequirementId,
        'conditions': value.conditions === undefined ? undefined : (value.conditions.map(ApiAlertConditionToJSON)),
        'id': value.id,
        'projectId': value.projectId,
    };
}
